import { useEffect, useState } from "react";
import client from "@/lib/api";

export function usePerms() {
  const [perms, setPerms] = useState(null);
  useEffect(() => {
    let on = true;
    client.get("/permissions/my").then((r) => { if (on) setPerms(r.data || {}); }).catch(() => {});
    return () => { on = false; };
  }, []);
  return { can: (k) => (perms ? perms[k] !== false : true), loaded: !!perms };
}
